import {Garage, Organization, PremiumService} from "@App/types";

/**
 * Checks if a premium service is allowed to appear in any way (hidden or not) in the list of premium services
 *  Can be used directly or as callback in array functions
 *
 * @param premiumService
 * @constructor
 */
export const PremiumServiceIsAllowedInlist = (premiumService: PremiumService): boolean => premiumService.show_in_list
/**
 * Checks if a premium service is allowed to appear in the filter for premiums services
 * Can be used directly or as callback in array functions
 *
 * @param premiumService
 * @constructor
 */
export const PremiumServiceIsFilterable = (premiumService: PremiumService): boolean => premiumService.filterable
/**
 * Checks if the premium service is visible in the list of premium services. If not it can be added as hidden for SEO purposes
 *
 * @param premiumService
 * @constructor
 */
export const PremiumServiceIsVisibleInList = (premiumService: PremiumService): boolean => PremiumServiceIsFilterable(premiumService)
/**
 * Checks if the garage has premium services that are allowed to appear in the list of premium services by checking if the property is an array
 * and if at least one of the premium services is allowed to appear in the list, hidden or not
 *
 * @param garage
 * @constructor
 */
export const GarageHasPremiumServicesForList = (garage: Garage): boolean => garage.premium_services && garage.premium_services.some(PremiumServiceIsAllowedInlist)
/**
 * Checks if the garage has premium services that are allowed to appear in the filter for premium services by checking if the property is an array
 * and if at least one of the premium services is allowed to appear in the filter
 *
 * @param garage
 * @constructor
 */
export const GarageHasFilterablePremiumServices = (garage: Garage): boolean => garage.premium_services && garage.premium_services.some(PremiumServiceIsFilterable)
/**
 * Checks if the garage has premium services that are visible in the list of premium services since some of them can be hidden. In that case we might not want to
 * show headline and such.
 *
 * @param garage
 * @constructor
 */
export const GarageHasPremiumServicesVisibleInList = (garage: Garage): boolean => GarageHasPremiumServicesForList(garage)

export const OrganizationHasPremiumServicesVisibleInList = (organization: Organization): boolean => organization.premium_services && organization.premium_services.some(PremiumServiceIsVisibleInList)
export const PremiumServiceIsReplacementOrPickup = (premiumService: PremiumService): boolean => ['Hol- & Bringservice', 'Ersatzwagen'].includes(premiumService.name)
